module.exports = __webpack_public_path__ + "static/media/dad2.38635051.jpg";